import {
  CreateOrUpdateAbsatzUmsatzZielMutation,
  CreateOrUpdateAbsatzUmsatzZielMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_OR_UPDATE_ABSATZ_UMSATZ_ZIEL } from './graphql/mutations';

export function useAbsatzUmsatzZielCreateOrUpdate() {
  const [execute, result] = useMutation<
    CreateOrUpdateAbsatzUmsatzZielMutation,
    CreateOrUpdateAbsatzUmsatzZielMutationVariables
  >(CREATE_OR_UPDATE_ABSATZ_UMSATZ_ZIEL, {
    refetchQueries: ['getUmsatzAbsatzZieleByStandortId'],
  });

  const createOrUpdateAbsatzUmsatzZiel = useCallback(
    (variables: CreateOrUpdateAbsatzUmsatzZielMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createOrUpdateAbsatzUmsatzZiel, result] as const;
}
